
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-label":"linkedin-svg"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('linkedin')]),_c('rect',{attrs:{"width":"50","height":"50","rx":"25","fill":"#fff"}}),_c('path',{attrs:{"d":"M20.35 33.188h-3.896V21.463h3.897v11.724zm-1.948-13.325h-.025c-1.308 0-2.153-.9-2.153-2.025 0-1.15.871-2.026 2.204-2.026 1.333 0 2.154.876 2.179 2.026 0 1.125-.846 2.025-2.205 2.025zm16 13.325h-3.897v-6.272c0-1.576-.564-2.651-1.974-2.651-1.076 0-1.717.725-2 1.425-.102.25-.127.6-.127.95v6.547h-3.897s.051-10.623 0-11.723h3.897v1.66c.518-.799 1.444-1.935 3.511-1.935 2.564 0 4.486 1.675 4.486 5.276v6.723z","fill":"#63756B"}})])
          )
        }
      }
    